<template>
  <section class="what-we-do">
    <div class="container">
      <div class="what-we-do-header">
        <h2 class="section-title">{{ headerData.title }}</h2>
      </div>
      
      <div class="services-grid">
        <div 
          v-for="(service, index) in servicesList" 
          :key="index"
          class="service-card wow fadeInUp" 
          :data-wow-delay="`${(index + 1) * 0.1}s`"
        >
          <div class="service-image">
            <img :src="service.image" :alt="service.alt" />
          </div>
          <div class="service-content">
            <h3 class="service-title">{{ service.title }}</h3>
            <p class="service-description">{{ service.description }}</p>
            <a :href="service.link" class="service-link">{{ service.linkText }}</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WhySogdoItsWhatWeDoComp",
  props: {
    headerData: {
      type: Object,
      required: true,
      default: () => ({
        title: "What we do"
      })
    },
    servicesList: {
      type: Array,
      required: true,
      default: () => []
    }
  }
};
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

/* What We Do Section */
.what-we-do {
  padding: 100px 0;
  background: #1a1a1a;
  position: relative;
}

.what-we-do-header {
  margin-bottom: 60px;
}

.section-title {
  font-size: 48px;
  font-weight: 700;
  color: #fff;
  font-family: 'Archivo', sans-serif;
  margin: 0;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.service-card {
  background: transparent;
  border-radius: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-image {
  width: 100%;
  height: 250px;
  overflow: hidden;
  margin-bottom: 30px;
}

.service-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.service-card:hover .service-image img {
  transform: scale(1.05);
}

.service-content {
  padding: 0 20px;
}

.service-title {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
  line-height: 1.3;
  font-family: 'Archivo', sans-serif;
}

.service-description {
  font-size: 16px;
  color: #ccc;
  line-height: 1.6;
  margin-bottom: 25px;
}

.service-link {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s ease;
  position: relative;
}

.service-link::after {
  content: '>';
  font-size: 18px;
  transition: transform 0.3s ease;
}

.service-link:hover {
  color: #F6EC4F;
}

.service-link:hover::after {
  transform: translateX(5px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .section-title {
    font-size: 36px;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .service-image {
    height: 200px;
  }
  
  .service-title {
    font-size: 20px;
  }
  
  .service-description {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 28px;
  }
  
  .service-image {
    height: 180px;
  }
  
  .service-title {
    font-size: 18px;
  }
  
  .service-description {
    font-size: 13px;
  }
  
  .service-link {
    font-size: 14px;
  }
}
</style>
